/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2026-03-26 11:21:50
 * @LastEditTime: 2026-08-11 09:51:40
 * @Description: 
 */
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import PlatformPage from "../pages/platform/page";
import MarketPage from "../pages/market/page";
import ContactPage from "../pages/contact/page";
import FAQPage from "../pages/faq/page";
import NewsPage from "../pages/news/page";
import LicensePage from "../pages/license/page";
import AndroidDownloadRedirect from "../pages/download/AndroidDownloadRedirect";
import WindowsDownloadRedirect from "../pages/download/WindowsDownloadRedirect";
import NonHongKongRoute from "../components/region/NonHongKongRoute";
import LegalDocumentPage from "../pages/legal/page";
import NewsDetailPage from "../pages/news/detail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/platform',
    element: <NonHongKongRoute><PlatformPage /></NonHongKongRoute>,
  },
  {
    path: '/market',
    element: <NonHongKongRoute><MarketPage /></NonHongKongRoute>,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/grand-opening',
    element: <NewsPage />, 
  },
  {
    path: '/news/:slug',
    element: <NewsDetailPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />, 
  },
  
  {
    path: '/license',
    element: <LicensePage />,
  },
  {
    path: '/terms',
    element: <LegalDocumentPage documentType="terms" />,
  },
  {
    path: '/privacy',
    element: <LegalDocumentPage documentType="privacy" />,
  },
  {
    path: '/risk-disclosure',
    element: <LegalDocumentPage documentType="risk" />,
  },
  {
    path: '/android-download',
    element: <NonHongKongRoute><AndroidDownloadRedirect /></NonHongKongRoute>,
  },
  {
    path: '/android-download/',
    element: <NonHongKongRoute><AndroidDownloadRedirect /></NonHongKongRoute>,
  },
  {
    path: '/android-download-choice',
    element: <NonHongKongRoute><AndroidDownloadRedirect /></NonHongKongRoute>,
  },
  {
    path: '/android-download-choice/',
    element: <NonHongKongRoute><AndroidDownloadRedirect /></NonHongKongRoute>,
  },
  {
    path: '/windows-download',
    element: <NonHongKongRoute><WindowsDownloadRedirect /></NonHongKongRoute>,
  },
  {
    path: '/windows-download/',
    element: <NonHongKongRoute><WindowsDownloadRedirect /></NonHongKongRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
 
